import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { GrayButton, GreenButton, TomatoButton } from '../../Layout/CommonStyle'
import { axiosPost } from '../../Common/Axios'
import toast from 'react-hot-toast'
import { RootState, useAppSelector } from '../../../store'
import { ResultJobs } from '../../../models/ResultJobs'
import { ApiResult } from '../../../models/Enums'

enum Mode {
  editMode,
  insertMode,
  displayMode,
}

function JobRegister() {
  const [resultJobs, setResultJobs] = useState<ResultJobs | undefined>(
    undefined
  )
  const [file, setFile] = useState<File | undefined>(undefined)
  const [localPosterUrl, setLocalPosterUrl] = useState<string>('')
  const [mode, setMode] = useState<Mode>(Mode.displayMode)
  const jobNameRef = useRef<HTMLInputElement>(null)
  const jobContentRef = useRef<HTMLTextAreaElement>(null)

  const me = useAppSelector((state: RootState) => state.user.me)

  const handleJobNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setResultJobs({ ...resultJobs, jobName: e.target.value } as ResultJobs)
  }

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setResultJobs({ ...resultJobs, jobContent: e.target.value } as ResultJobs)
  }

  // 포스터 이미지 업로드
  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (e.target.files === null || e.target.files.length < 1) return
      e.preventDefault()
      e.persist()
      e.stopPropagation()

      setFile(e.target.files[0])

      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onloadend = () => {
        setLocalPosterUrl(reader.result as string)
      }
    } catch (err) {
      console.log('upload_poster error', err)
    }
  }

  // 등록
  const handleRegist = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()

    try {
      if (!resultJobs) {
        console.log('handleRegist', 'resultJobs is null')
        return
      }

      if (resultJobs.jobName === '') {
        toast.error('직업명을 입력해주세요')
        return
      }
      if (resultJobs.jobContent === '') {
        toast.error('직업이 하는 일을 입력해주세요')
        return
      }
      if (mode === Mode.insertMode && !file) {
        toast.error('포스터를 선택하세요.')
        return
      }

      const formData = new FormData()
      if (file) {
        formData.append('file', file)
      }
      formData.append('userGroupId', me.groupId.toString())
      formData.append('userId', me.id.toString())
      formData.append('id', resultJobs.id.toString())
      formData.append('writeUserId', resultJobs.id.toString())
      formData.append('jobName', resultJobs.jobName)
      formData.append('jobContent', resultJobs.jobContent)
      formData.append('posterUrl', resultJobs.posterUrl)

      const result = await axiosPost(
        '/api/jobs/save_result_jobs',
        formData,
        true
      )
      console.log('uploadPoster', result)
      if (result.apiResult !== ApiResult.SUCCESS) {
        console.log('handleUpload', result)
        toast.error('등록에 실패했습니다')

        return
      }

      setResultJobs(result.data)
      console.log('handleRegist', result.data)

      toast.success('등록되었습니다')
      setMode(Mode.displayMode)
    } catch (error) {
      console.log('error', error)
    }
  }

  const getResultJobs = async () => {
    try {
      const payload = {
        userGroupId: me.groupId,
        userId: me.id,
      }

      const result = await axiosPost('/api/jobs/get_result_jobs', payload)
      if (result.apiResult !== ApiResult.SUCCESS) {
        console.log(getResultJobs, result)

        setResultJobs({
          id: 0,
          userGroupId: me.groupId,
          writeUserId: me.id,
          jobName: '',
          jobContent: '',
          posterUrl: '',
        } as ResultJobs)
        setMode(Mode.insertMode)

        return
      }

      console.log('getResultJobs', result.data)

      setResultJobs(result.data)

      if (result.data.jobName === '') {
        setMode(Mode.insertMode)
      } else {
        setMode(Mode.displayMode)
      }
    } catch (error) {
      console.log('getResultJobs error', error)
    }
  }

  useEffect(() => {
    getResultJobs()
  }, [])

  return (
    <Container>
      <Explain>만들어진 직업명을 입력하고 어떤 직업인지 설명해주세요.</Explain>

      {mode === Mode.displayMode ? (
        <Contents>
          <Buttons>
            <div></div>
            <div>
              <GreenButton onClick={() => setMode(Mode.editMode)}>
                수정하기
              </GreenButton>
            </div>
          </Buttons>
          <Content>
            <div>직업명</div>
            <div>{resultJobs ? resultJobs.jobName : ''}</div>
          </Content>
          <Content>
            <div>직업이 하는 일</div>
            <div>
              <pre>{resultJobs ? resultJobs.jobContent : ''}</pre>
            </div>
          </Content>
          <Content>
            <div>포스터</div>
            <div>
              {resultJobs && resultJobs.posterUrl && (
                <img
                  src={process.env.PUBLIC_URL + resultJobs.posterUrl}
                  alt=""
                />
              )}
            </div>
          </Content>
        </Contents>
      ) : (
        <EditContents>
          <Content>
            <div>직업명</div>
            <div>
              <input
                type="text"
                ref={jobNameRef}
                onChange={handleJobNameChange}
                value={resultJobs ? resultJobs.jobName : ''}
              />
            </div>
          </Content>
          <Content>
            <div>직업이 하는 일</div>
            <div>
              <textarea
                ref={jobContentRef}
                onChange={handleContentChange}
                value={resultJobs ? resultJobs.jobContent : ''}
                rows={10}
              ></textarea>
            </div>
          </Content>
          <Content>
            <div>포스터</div>
            <div>
              <input type="file" onChange={handleUpload} accept="image/*" />
            </div>
          </Content>
          <div>
            {localPosterUrl ? (
              <img src={localPosterUrl} alt="" />
            ) : (
              resultJobs &&
              resultJobs.posterUrl && (
                <img
                  src={process.env.PUBLIC_URL + resultJobs.posterUrl}
                  alt=""
                />
              )
            )}
          </div>
          <Buttons>
            <div></div>
            <div>
              <TomatoButton onClick={async (e) => await handleRegist(e)}>
                저장
              </TomatoButton>
              {mode === Mode.editMode && (
                <GrayButton
                  onClick={() => {
                    setMode(Mode.displayMode)
                  }}
                >
                  취소
                </GrayButton>
              )}
            </div>
          </Buttons>
        </EditContents>
      )}
    </Container>
  )
}

const Container = styled.div`
  width: 1020px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  min-height: 80vh;
  padding-bottom: 80px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  img {
    width: 80%;
    padding-left: 100px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0;
    }
  }
`

const Explain = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  font-size: 1.1rem;
`

const Contents = styled.div`
  padding: 10px;
  input {
    padding: 5px;
  }
  img {
    padding: 5px;
    width: 600px;
    height: 600px;
    object-fit: contain;
    box-sizing: border-box;
    object-position: left top;

    @media (max-width: 768px) {
      width: 100%;
      height: auto;
    }
  }
  pre {
    font-size: 1rem;
    margin: 0;
  }
`

const EditContents = styled.div`
  padding: 10px;
  input {
    padding: 5px;
  }
  img {
    padding: 5px;
    margin-left: 150px;
    width: 600px;
    height: 600px;
    object-fit: contain;
    object-position: center top;
    box-sizing: border-box;
    border: 1px solid #eee;

    @media (max-width: 768px) {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 2px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 8px;
  }

  & > div:nth-child(1) {
    width: 100px;
    text-align: center;
    background-color: aliceblue;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  & > div:nth-child(2) {
    width: 600px;
    @media (max-width: 768px) {
      width: 100%;
    }

    input {
      width: 100%;
      box-sizing: border-box;
    }
  }

  & > div {
    padding: 8px 15px;
    @media (max-width: 768px) {
      padding: 3px 0;
    }
  }

  textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    @media (max-width: 768px) {
      margin-top: 5px;
    }
  }
`

const Buttons = styled.div`
  text-align: right;
  width: 75%;
  margin-bottom: 20px;
`

export default JobRegister
